import * as relation from "../base/relation";
import { UTILS } from "../../utils";

/**
 * 合化冲算法
 * Auther:::ElvaChan
 * Date:::20191026
 */
var HE_HUA_CHONG = {
    
    /**
     * 获取所有柱的合化冲关系
     * @param {所有柱的列表} allZhu 
     */
    getAllListHeHuaChong(allZhu) {
        var ganList = [], zhiList = [], 
            tianganResult = {}, dizhiResult = {}, 
            tgResultList = [], dzResultList = [], resultList = [];
        allZhu.forEach(ganzhi => {
            ganList.push(ganzhi.charAt(0));
            zhiList.push(ganzhi.charAt(1));
        });
        // console.log('zhiList------', ganList, zhiList)

        // 获取天干合、天干冲
        ganList.forEach((text, index) => {
            var heResult = this.getTianGanDiZhiHe('tiangan', text, index, ganList)
            var chongResult = this.getTianGanDiZhiChong('tiangan', text, index, ganList)
            tianganResult = Object.assign(tianganResult, heResult.he)
            tianganResult = Object.assign(tianganResult, chongResult.chong)
        })

        // 获取地支 三会、三合、合、冲、相刑、自刑
        zhiList.forEach((text, index) => {
            if(text != '') {
                var heHuiResult = this.getSanHeSanHui(text, index, zhiList);
                var heResult = this.getTianGanDiZhiHe('dizhi', text, index, zhiList);
                var chongResult = this.getTianGanDiZhiChong('dizhi', text, index, zhiList);
                var xiangXingResult = this.getXiangXing(text, index, zhiList);
                var zixingResult = this.getZiXing(text, index, zhiList);
                dizhiResult = Object.assign(dizhiResult, heHuiResult.sanhui)
                dizhiResult = Object.assign(dizhiResult, heHuiResult.sanhe)
                dizhiResult = Object.assign(dizhiResult, heResult.he)
                dizhiResult = Object.assign(dizhiResult, chongResult.chong)
                dizhiResult = Object.assign(dizhiResult, xiangXingResult.xiangxing)
                dizhiResult = Object.assign(dizhiResult, zixingResult.zixing)
            }
        });

        // 返回数组
        for(var k in tianganResult) {
            tgResultList.push(tianganResult[k])
        }
        for(var kk in dizhiResult) {
            dzResultList.push(dizhiResult[kk])
        }
        tgResultList.sort((a, b) => {return a.type - b.type})
        dzResultList.sort((a, b) => {return a.type - b.type})
        resultList = [tgResultList, dzResultList];
        console.log('getAllListHeHuaChong------', resultList);
        return resultList;
    },

    /**
     * 获取天干地支合
     * @param {类型} type : tiangan || dizhi 
     * @param {数据文本} text 
     * @param {数据文本索引} index 
     * @param {数据文本列表} list 
     */
    getTianGanDiZhiHe(type, text, index, list) {
        var compList, heResultList, heResult = {}, resultData = {};
        if(type == 'tiangan'){
            compList = relation.RELATION_TIGAN_HE;
            heResultList = relation.RELATION_TIGAN_HE_RESULT;
        }else if(type == 'dizhi'){
            compList = relation.RELATION_DIZHI_HE;
            heResultList = relation.RELATION_DIZHI_HE_RESULT;
        }

        var textI = UTILS.getTextIndexInStringArray(compList, text);
        var heT = compList[textI].replace(text, '');
        var heIndex = list.indexOf(heT);
        // 已经处理过的就不用再重复追加:eg 午未 not 未午
        if(heIndex != -1){
            var str = [index, heIndex].sort().join(''), strArr = str.split('');
            heResult['he' + str] = {
                type: 3,
                index: strArr,
                length: parseInt(strArr[1] - strArr[0] + 1),
                text: list[strArr[0]] + list[strArr[1]], 
                result: '合化' + heResultList[textI]
            }
            // console.log('getTianGanDiZhiHe----', text, index, list, heResult)
        }
        resultData['he'] = heResult;
        return resultData;
    },

    /**
     * 获取天干地支冲
     * @param {类型} type : tiangan || dizhi 
     * @param {数据文本} text 
     * @param {数据文本索引} index 
     * @param {数据列表} list 
     */
    getTianGanDiZhiChong(type, text, index, list) {
        var compList, chongResult = {}, resultData = {};
        if(type == 'tiangan'){
            compList = relation.RELATION_TIGAN_CHONG;
        }else if(type == 'dizhi') {
            compList = relation.RELATION_DIZHI_CHONG;
        }

        var textI = UTILS.getTextIndexInStringArray(compList, text);
        // 天干冲不包含:戊己
        if(!compList[textI]){
            return resultData;
        }
        var chongT = compList[textI].replace(text, '');
        var chongIndex = list.indexOf(chongT);
        if(chongIndex != -1){
            var str = [index, chongIndex].sort().join(''), strArr = str.split('');
            chongResult['chong' + str] = {
                type: 4,
                index: strArr,
                length: parseInt(strArr[1] - strArr[0] + 1),
                text: list[strArr[0]] + list[strArr[1]], 
                result: '相冲'
            }
            // console.log('getTianGanDiZhiChong----', text, index, list, chongResult)
        }
        
        resultData['chong'] = chongResult;
        return resultData;
    },
    
    /**
     * 获取地支三会三合
     * @param {数据文本} text 
     * @param {数据文本索引} index 
     * @param {数据列表} list 
     */
    getSanHeSanHui(text, index, list) {
        var sanhuiList = relation.RELATION_DIZHI_SAN_HUI,
            sanheList = relation.RELATION_DIZHI_SAN_HE,
            shResultList = relation.RELATION_DIZHI_SAN_HE_HUI_RESULT,
            huiResult = {}, heResult = {}, resultData = {};

        var sanhuiI = UTILS.getTextIndexInStringArray(sanhuiList, text),
            sanhuiT = sanhuiList[sanhuiI].replace(text, '').split(''),
            sanhuiI1 = list.indexOf(sanhuiT[0]),
            sanhuiI2 = list.indexOf(sanhuiT[1]),
            sanheI = UTILS.getTextIndexInStringArray(sanheList, text),
            sanheT = sanheList[sanheI].replace(text, '').split(''),
            sanheI1 = list.indexOf(sanheT[0]),
            sanheI2 = list.indexOf(sanheT[1]);
        
        // 三会的另外2个字都在数组内
        if(sanhuiI1 != -1 && sanhuiI2 != -1){
            var str1 = [index, sanhuiI1, sanhuiI2].sort().join(''), strArr1 = str1.split('');
            huiResult['sanhui' + str1] = {
                type: 1,
                index: strArr1,
                length: parseInt(strArr1[2] - strArr1[0] + 1),
                text: list[strArr1[0]] + list[strArr1[1]] + list[strArr1[2]], 
                result: '三会' + shResultList[sanhuiI]
            }
            // console.log('sanhui---ok-----', index, sanhuiI1, sanhuiI2);
            // console.log('sanhe---sanhui---------', text, index, sanhuiI, sanhuiT, sanhuiI1, sanhuiI2);
        }

        // 三合的另外2个字都在数组内
        if(sanheI1 != -1 && sanheI2 != -1){
            var str2 = [index, sanheI1, sanheI2].sort().join(''), strArr2 = str2.split('');
            heResult['sanhe' + str2] = {
                type: 2,
                index: strArr2, 
                length: parseInt(strArr2[2] - strArr2[0] + 1),
                text: list[strArr2[0]] + list[strArr2[1]] + list[strArr2[2]], 
                result: '三合' + shResultList[sanheI]
            }
            // console.log('sanhe---ok-----', index, sanheI1, sanheI2);
            // console.log('sanhe---sanhui---------', text, index, sanheI, sanheT, sanheI1, sanheI2);
        }

        resultData['sanhui'] = huiResult;
        resultData['sanhe'] = heResult;
        return resultData;
    },

    /**
     * 获取相刑
     * @param {数据文本} text 
     * @param {数据文本索引} index 
     * @param {数据列表} list 
     */
    getXiangXing(text, index, list) {
        var xiangxingList = relation.RELATION_XIANG_XING, xiangxingResult = {}, resultData = {},
            textI = UTILS.getTextIndexInStringArray(xiangxingList, text);
        
        if(!xiangxingList[textI]){
            return resultData;
        }
        xiangxingList.forEach(xxText => {
            if(xxText.indexOf(text) != 0){
                var xiangxingT = xxText.replace(text, '');
                var xiangxingI = list.indexOf(xiangxingT);
                if(xiangxingI != -1) {
                    var str = [index, xiangxingI].sort().join(''), strArr = str.split('');
                    xiangxingResult['xiangxing' + str] = {
                        type: 5,
                        index: strArr,
                        length: parseInt(strArr[1] - strArr[0] + 1),
                        text: list[strArr[0]] + list[strArr[1]], 
                        result: '相刑'
                    }
                }
            }
            
        })

        resultData['xiangxing'] = xiangxingResult;
        return resultData;
    },

    /**
     * 获取自刑
     * @param {数据文本} text 
     * @param {数据文本索引} index 
     * @param {数据列表} list 
     */
    getZiXing(text, index, list) {
        var zixingList = relation.RELATION_ZI_XING, zixingResult = {}, resultData = {},
            textI = zixingList.indexOf(text);
        
        if(textI != -1){
            list.forEach((newText, newIndex) => {
                // console.log('newText---', text, newText, index, newIndex)
                if(newText == text && newIndex != index) {
                    var str = [index, newIndex].sort().join(''), strArr = str.split('');
                    if(!zixingResult['zixing' + str]){
                        zixingResult['zixing' + str] = {
                            type: 6,
                            index: strArr,
                            length: parseInt(strArr[1] - strArr[0] + 1),
                            text: list[index] + list[newIndex], 
                            result: '自刑'
                        }
                    }
                }
            })
        }else{
            return resultData;
        }
        // console.log('getZixing-----', text, index, textI);

        resultData['zixing'] = zixingResult;
        return resultData;
    }
}

export {
    HE_HUA_CHONG
}